import { Link } from 'react-router-dom'; // Added for navigation
import '../assets/styles/Services.css';

function Services() {
  const services = [
    {
      title: "Ocean Freight",
      image: "/assets/images/1-1.png",
      description: "Reliable and cost-effective ocean transport solutions for global shipping.",
      route: "/services/ocean-freight",
    },
    {
      title: "Air Freight",
      image: "/assets/images/2-1.png",
      description: "Fast and secure air transport for time-sensitive shipments.",
      route: "/services/air-freight",
    },
    {
      title: "Contract Logistic",
      image: "/assets/images/3-1.png",
      description: "Comprehensive logistics solutions tailored to your needs.",
      route: "/services/logistics", // Assuming this maps to Logistics.jsx
    },
    {
      title: "Cargo Express",
      image: "/assets/images/4-1.png",
      description: "Swift and efficient express cargo delivery services.",
      route: "/services/cargo-express",
    },
  ];

  return (
    <section className="services-section py-5 bg-white">
      <div className="container">
        <div className="row row-cols-1 row-cols-md-4 g-4">
          {services.map((service, index) => (
            <div key={index} className="col">
              <div className="card h-100 text-center">
                <img
                  src={service.image}
                  className="card-img-top"
                  style={{ height: '200px', objectFit: 'cover' }}
                  alt={service.title}
                />
                <div className="card-body">
                  <h5 className="card-title">{service.title}</h5>
                  <p className="card-text">{service.description}</p>
                  <Link to={service.route} className="btn btn-view-details mt-3">
                    More Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;